import React, { Component } from 'react'
import { connect } from 'react-redux'

import Part from '../Part'
import Photo from '../Photo'
import Comment from '../Comment'

import { UpdateOrderFileSelection } from '../../../../actions/orders'

import { translation } from '../../../../utils/helpers'

// Elements
import Button from '../../../elements/button'
import PanelHeader from '../../../elements/panelHeader'

class OtherDamages extends Component {
  constructor (props) {
    super(props)
    this.state = {
      price: null,
      order: null,
      otherDamage: null
    }

    this.setComment = this.setComment.bind(this)
  }

  componentDidMount () {
    this.props.onRef(this)
  }

  componentWillUnmount () {
    this.props.onRef(undefined)
  }

  componentWillReceiveProps (next) {
    if (typeof next.orderPrice !== 'object') return

    const price = next.orderPrice
    let otherDamage = this.findInactiveOtherDamage(price)

    if (!otherDamage) {
      otherDamage = {
        Id: 0,
        Active: false,
        StepId: this.props.order.StepId
      }

      this.setState({
        price: price,
        otherDamage: otherDamage
      }, () => {
        this.savePrice()
      })
    } else {
      this.setState({
        price: price,
        order: next.order,
        otherDamage: otherDamage
      })
    }
  }

  getTitle () {
    if (this.props.orderPrice === null) return null
    return translation('15188')
  }

  savePrice () {
    let price = this.state.price
    price.OtherDamages = [...price.OtherDamages, this.state.otherDamage]

    return this.props.saveOrderPrice(price)
  }

  findInactiveOtherDamage (price) {
    return price.OtherDamages.find(od => !od.Active)
  }

  setComment (comment) {
    return new Promise(resolve => {
      this.setState({
        otherDamage: {
          ...this.state.otherDamage,
          Comment: comment
        }
      }, () => {
        this.savePrice().then(() => {
          resolve()
        })
      })
    })
  }

  onDelete (part, damage) {
    if (part && damage) {
      part.OtherDamages.map(x => {
        if (x.Id === damage.Id) x.IsDeleted = true
        return x
      })

      this.state.price.Parts.map(x => {
        if (x.Part.TaskSide === part.Part.TaskSide && x.Part.PartItemId === part.Part.PartItemId) x = part
        return x
      })

      this.savePrice()
    }
  }

  renderOtherDamage () {
    const price = { ...this.state.price }
    const inactiveDmg = this.state.otherDamage// this.findInactiveOtherDamage(price)
    const filteredParts = price.Parts.reduce((filtered, part) => {
      const inactiveParts = part.OtherDamages.filter(od => od.OtherDamageId === inactiveDmg.Id)

      if (inactiveParts.length > 0) {
        return [...filtered, { ...part, OtherDamages: inactiveParts }]
      }
      return filtered
    }, [])
    const renderPart = (part) => {
      return (
        <Part
          key={'part_' + part.Part.PartItemId + '_' + part.Part.TaskSide}
          part={part}
          onDelete={this.props.editable && this.onDelete.bind(this, part)} />
      )
    }

    return (
      <div>
        <PanelHeader text={translation('15188')} />
        {filteredParts.map(renderPart)}
      </div>
    )
  }

  render () {
    if (!this.state.price || !this.state.order || !this.state.otherDamage) return null

    const goBack = () => {
      const price = this.state.price
      let hasDamages = false
      const validOtherDamage = this.state.otherDamage
      price.Parts.forEach(p => {
        if (!hasDamages) {
          hasDamages = !!p.OtherDamages.find(od => od.OtherDamageId === validOtherDamage.Id)
        }
      })

      if (price.Parts.length === 0 || !hasDamages) {
        window.toastr.error(translation('15189'), translation('216'))
      } else {
        let orderFileIds = []
        let inputs = document.getElementsByTagName('input')
        for (let i = 0; i < inputs.length; i++) {
          if (inputs[i].name === 'checkbox_image' && inputs[i].checked === true) {
            orderFileIds.push(inputs[i].id)
          }
        }

        this.props.UpdateOrderFileSelection({
          OrderFileIds: orderFileIds,
          Type: 7,
          Step: this.state.order.StepId,
          TypeId: this.state.otherDamage.Id
        })

        // this.ensureSaved().then(() => {
        this.setState({
          otherDamage: {
            ...this.state.otherDamage,
            Active: true
          }
        }, () => {
          this.savePrice().then(() => {
            this.props.goBack()
          })
        })
        // })
      }
    }

    const comment = this.state.otherDamage.Comment

    let css = 'price__view'
    if (this.props.editable) {
      css += ' editable'
    }

    return (
      <div className={css}>
        {this.props.viewMode === 'mobile' && this.props.renderInside()}
        <PanelHeader text={translation('889')} />
        {this.renderOtherDamage()}
        <Photo
          saveOrder={this.props.saveOrder}
          saveOrderPrice={this.props.saveOrderPrice}
          orderPrice={this.state.price}
          order={this.state.order}
          loadOrder={this.props.loadOrder}
        />
        <Comment
          comment={comment}
          changeSource={19}
          orderPriceId={this.state.price.OrderPriceId}
          order={this.state.order}
          setComment={this.setComment}
          // onRef={ref => {
          //   this.ensureSaved = ref
          // }}
        />
        {this.props.editable && <Button onClick={goBack} labelText={translation('956')} />}
      </div>
    )
  }
}

export default connect(null, {
  UpdateOrderFileSelection
})(OtherDamages)



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/OtherDamages/index.js